module.exports = __webpack_public_path__ + "static/media/proj20_img10.b171ab85.jpg";